const EndUrls = {
   login: "login",

   // USER
   addUser: "/user/add",
   listUser: "/user",
   editUser: "/user/update",
   changeUserStatus: "/user/status_change",
   userDelete: (id) => `/user/delete/${id}`,
   userChangePassword: (id) => `/user/change-password/${id}`,

   // ROLE MASTER
   roleDelete: (id) => `/role/delete/${id}`,
   changeRoleStatus: "/role/status_change",

   // Dashboard
   currentOpenTrip: "/current-trip/open",
   unassignedTripVehicles: "/unassigned-trip-vehicles",

   // CONTRACTOR MASTER
   contractorAdd: "/contractor/add",
   contractorList: "/contractor",
   contractorUpdate: "/contractor/update",
   singleContractorMaster: (id) => `/contractor/fetch/${id}`,
   singleConractorContactDetails: (id) =>
      `/contractor/fetch/${id}`,
   singleConractorContactAdd: "/contractor/add/child",
   singleConractorContactEdit: "/contractor/update/child",
   changeContractorStatus: "/contractor/status_change",

   // Dropdown data
   getDropdownData: "/fleet/get_dropdowns",
   getDriverDropdownData: "/trip/get-vehicle-driver",
   getCustomerDropdownData: "/customer/get-dropdowns",

   // Fleet Master
   fetchAllFleets: "/fleet/records",
   fetchFleetRecordById: (id) => `/fleet/records/${id}`,
   fetchAllUniqueFleet: "/fleet/records/unique",
   fetchAllFleetsEdit: "/trip-edit/fleet/records",
   addFleet: "/fleet/add",
   addVehicleAndEmiDetails: "/fleet/add-vehicle-details",
   addServiceRecord: "/fleet/add-service-record",
   listFleet: "/fleets",
   fetchSingleFleet: (id) => `/fleet/fetch/${id}`,
   updateFleet: "/fleet/update",
   downloadFleet: "/generate-pdf",
   changeFleetStatus: "/fleet/status_change",
   listExpiredFleet: "/fleet-expired-docs-records",
   fetchFleetAssignmentFleetList: "/fleet/filtered",
   updateFleetAssignment: "/fleet/update-assignment",
   unassignFleet: "/fleet/unassigned",
   trackVehicle: (regNo) => `/fleet/track/${regNo}`,

   // driver master
   fetchAllContractors: "/contractor",
   addDriverMaster: "/driver/add",
   listDriverMaster: "/driver",
   fetchSingleDriverMaster: (id) => `/api/driver/fetch/${id}`,
   updateDriverMaster: "/driver/update",
   changeDriverStatus: "/driver/status_change",
   getDriverRecordByVendorId: (id) => `/driver/fetch/fleet/${id}`,
   fetchFleetAssignmentDriverList: "/driver/no-open-trips",

   // customer master
   // fetchAllCustomers: "customer?&model_id=6&action_id=3",
   addCustomerMaster: "/customer/add",
   listCustomerMaster: "/customer",
   customerDropdownList: "/customer",
   // fetchSingleDriverMaster: (id) =>
   //   `api/driver/fetch/${id}?&model_id=4&action_id=3`,
   updateCustomerMaster: (id) => `/customer/${id}`,
   changeCustomerStatus: "/customer/status_change",

   // Location Master
   addLocationMaster: "/location/add",
   locationMasterList: "/location?&model_id=10&action_id=3",
   locationMasterSingleList: (id, model_id, action_id) =>
      `/location/fetch/${id}?model_id=${model_id}&action_id=${action_id}`,
   locationMasterUpdate: "/location/update",
   changeLocationStatus: "/location/status_change",
   locationMasterDelete: (id) => `/location/delete/${id}`,

   // Node Master
   addNodeMaster: "/node-master/add",
   nodeMasterList: "/lane/route/nodes",
   nodeMasterSingleList: (id, model_id, action_id) =>
      `/node-master/fetch/${id}?model_id=${model_id}&action_id=${action_id}`,
   nodeMasterUpdate: "/node-master/update",
   changeNodeStatus: "/node-master/status_change",
   nodeMasterDelete: (id) => `/node-master/delete/${id}`,

   // Consignment Master
   consignmentList: "/consignments",
   consignmentLrList: "/consignments/lr-list",
   consignmentSingle: (id) => `/consignments/${id}`,
   consignmentLR: (id) => `/consignments/${id}/lr`,
   consignmentAdd: "/consignments",
   consignmentUpdate: (id) => `/consignments/${id}`,
   consignmentDelete: (id) => `/consignments/${id}`,

   // Company Master
   addCompanyMaster: "/company/add",
   companyMasterList: "/companies",
   companyMasterSingleList: (id) => `/company/fetch/${id}`,
   companyMasterUpdate: "/company/update",

   // kiloleter master
   addKiloleterMaster: "/kiloleter/add",
   kiloleterMasterList: "/kiloleters",
   kiloleterMasterSingleList: (id) => `/kiloleter/fetch/${id}`,
   kiloleterMasterUpdate: "/kiloleter/update",
   kiloleterMasterDelete: (id) => `/kiloleter/delete/${id}`,

   // reports
   filterDropDown: "/reports/drop-down-records",
   loadingReportMasterList: "/reports/loading-report",
   vehicleShortageSummaryMasterList: "/reports/vehicle-shortage-report",
   tripExpensesSummaryMasterList: "/reports/trip-expenses-report",
   performanceReportMasterList: "/reports/performance-report",
   monthlyLoadingGraphList: "/reports/monthly-loading-graph-list",

   // Tonnage
   addTonnageMaster: "/tonnage",
   tonnageList: "/tonnages",
   changeTonnageStatus: "/tonnage/status_change",
   tonnageMasterSingleList: (id) => `/tonnage/${id}`,
   tonnageMasterUpdate: "/tonnage",
   tonnageMasterDelete: (id) => `/tonnage/delete/${id}`,

   // vehicle category
   categoryList: "/vehicle-categories",
   addVehicleCategory: "/vehicle-category/add",
   changeCatgoryStatus: "/vehicle-category/status_change",
   categorySingleRecord: (id) => `/vehicle-category/fetch/${id}`,
   updateVehicleCategory: "/vehicle-category/update",

   // lane master
   getAllVendors: "/vendor/get_all_vendors?&model_id=7&action_id=3",
   getAllLane: "/lane",
   listLaneMaster: "/lane-cust-vend-map?&model_id=8&action_id=3",
   addLaneMaster: "/lane-cust-vend-map/add",
   updateLane: "/lane-cust-vend-map/update",
   fetchSingleLaneMaster: (id) =>
      `/api/lane-cust-vend-map/fetch/${id}?&model_id=8&action_id=3`,
   changeLaneStatus: "/lane-master/status_change",
   listTripAddEdit: "/lane-with-rate",

   // all lane record
   getAllLanes: "/lane",
   getLaneDetail: (id) => `/lane/${id}`,

   // Trip master
   addTripMaster: "/trip/create-trip",

   // Helper Master
   addHelperMaster: "/helper/add",
   listHelperMaster: "/helper?&model_id=5&action_id=3",
   updateHelperMaster: "/helper/update",
   changeHelperStatus: "/helper/status_change",

   // Get all lane
   listLane: "/lane?&model_id=8&action_id=3",

   // Vendor Master
   addVendorMaster: "/vendor/add",
   listVendorMaster: "/vendor?&model_id=7&action_id=3",
   contactPersonDetails:
      "/api/vendor/fetch/child/1?&table_name=contact_person_details&model_id=7&action_id=3",
   changeVendorStatus: "/vendor/status_change",

   // Trip
   listTrip: "/trip/get-trip?model_id=1&action_id=3",
   listTripByPagination: "/trip/get-trip-by-pagination?model_id=2&action_id=3",
   singleTrip: (id) => `/trip/get-trip-info/${id}?model_id=2&action_id=3`,
   updateTripManager: "/trip/corporate-trip-update",
   updateTripDetails: "/trip/update-trip-details",
   approveTripDetails: "/trip/approve-trip-details",
   rejectTripDetails: "/trip/reject-trip-details",
   updateTripReviewStatus: "/trip/update-status",
   updateAdhocTripReviewStatus: "/trip/update-adhoc-trip-status",
   tripDashboardReport: "/dashboard",

   managerTripList: (id) => `/trip/get-manager-trip/${id}?model_id=2&action_id=3`,
   addhocLaneAdd: "/trip/create-adhoc-lane",
   adhocLaneEdit: "/trip/update-adhoc-lane",
   getAdhocLaneList: (model_id, action_id) =>
      `/trip/get-adhoc-lane?model_id=${model_id}&action_id=${action_id}`,
   getAdhocLane: (lane_id, model_id, action_id) =>
      `/trip/get-adhoc-lane-info/${lane_id}?model_id=${model_id}&action_id=${action_id}`,

   updateAdhocLaneReviewStauts: "/trip/approvereject-adhoc-lane",

   getUniqueAdhocLaneList: "/adhoc-lane/unique-list",
   getAdhocLaneById: (id) => `/adhoc-lane/${id}`,

   //All adhoc trip list
   adhocTripList: "/trip/get-adhoc-trip?model_id=2&action_id=3",
   adhocTripListByPagination: "/trip/get-adhoc-trip-by-pagination?model_id=2&action_id=3",
   // Single adhoc trip
   getSingleAdhocTrip: (id) => `/trip/get-adhoc-trip-info/${id}?model_id=2&action_id=3`,
   // Adhoc trip update manager
   adhocTripUpdateManager: "/trip/corporate-adhoctrip-update",

   createActual: "/trip/create-actual",
   createActualAdhoc: "/trip/create-actual-adhoc",

   // reports
   fleetReport: "/report/fleet-master",
   fleetMaintainanceReport: "/report/fleet-master-maintainance",
   customerMasterReport: "/report/customer-master",
   fleetEMIVendorReport: "/report/fleet-emi-vendor-master",
   fleetEMIReport: "/report/fleet-emi-master",
   fleetExpirationReport: "/report/fleet-expiration-master",
   vendorMasterReport: "/report/vendor-master",
   driverMasterReport: "/report/driver-master",
   driverSalaryReport: "/report/driver-master-sal",
   helperMasterReport: "/report/helper-master",
   contractorMasterReport: "/report/contractor-master",
   laneMasterReport: "/report/lane",
   tripMasterReport: "/report/trip",

   // Unit status
   changeUnitStatus: "/unit/status_change",

   // Config
   addConfig: "/config/add",
};

export default EndUrls;
